import { http, uploadFile } from '@/utils/axios'

/**
 * @msg: 获取课程考核评分标准
 */
export function getCourseScale(data) {
    return http({
        url: http.baseUrl('zkolCourseCheckMarkScale/getScale'),
        method: 'get',
        params: http.params(data)
    })
}

/**
 * @msg: 保存课程考核评分标准
 */
export function saveCourseScale(data) {
    return http({
        url: http.baseUrl('zkolCourseCheckMarkScale/saveOrUpdate'),
        method: 'post',
        params: http.params(data),
        data: data
    })
}